import { Button, Drawer, Form, message } from 'antd';
import React from 'react';
import { fieldGenerator, getErrorOnField } from "utilities/form";
import { CaseService } from '../../../services';



class EligibilityCalculatorDrawer extends React.Component{
    fieldGenerator = fieldGenerator.bind(this.props.form);
    getErrorOnField = getErrorOnField.bind(this.props.form);
    state = {
        loading : false
    }


    handleFormSubmit = (e) => {
        e.preventDefault();
        let data  = {
            [this.props.currentActiveFormKey]: this.props.form.getFieldsValue()
        }
        this.setState({
            loading : true
        })
        this.props.form.validateFields((err, values) => {
            if (!err) {
                CaseService.submitEligibilityCalculatorDetails(this.props.caseId , data)
                .then((resp) => {
                    this.props.fetchEligibilityCalculatorDetails();
                    this.props.onClose();
                    this.setState({
                        loading : false
                    })
                })
                .catch((err) => {
                    message.error("Something went wrong!")
                    this.setState({
                        loading : false
                    })
                })
            }
        });
    }
    render(){
        return (

            <Drawer
                title="Create a new account"
                width={620}
                onClose={this.props.onClose}
                visible={this.props.visible}
                bodyStyle={{ paddingBottom: 80 }}
            >
                <Form className='d-flex flex-row align-items-end justify-content-space-between flex-wrap w-100 mb-10' onSubmit={this.handleFormSubmit}>
                    {this.props.formFields
                        .map((field, fieldName) => {
                            // field.rules = [
                            //     {
                            //         required: true,
                            //         message: "Field is mandatory"
                            //     },
                            //     {
                            //         pattern: /^(100|[1-9]?[0-9](\.\d{1,2})?)$/,
                            //         message: "Enter number between 0 to 100"
                            //     }
                            // ];

                            if (fieldName === "unutilised_limit") {
                                const odLimit = this.props.form.getFieldValue('od_limit');
                                const avgUtilizedLimit = this.props.form.getFieldValue('average_utilized_limit');
                                const unutilizedLimit = this.props.form.getFieldValue('unutilised_limit');
                                
                                if (odLimit != null && avgUtilizedLimit != null) {
                                    const calculatedLimit = (Number(odLimit) - Number(avgUtilizedLimit)).toFixed(2);
                                    if (unutilizedLimit !== calculatedLimit) {
                                        this.props.form.setFieldsValue({
                                            unutilised_limit: calculatedLimit
                                        });
                                    }
                                }
                            }
                            if (fieldName === "total_abb") {
                                const abbLastSixMonths = this.props.form.getFieldValue('abb_last_six_months');
                                const unutilisedLimit = this.props.form.getFieldValue('unutilised_limit');
                                const totalAbb = this.props.form.getFieldValue('total_abb');

                                if (abbLastSixMonths != null && unutilisedLimit != null) {
                                    const calculatedLimit = (Number(abbLastSixMonths) + Number(unutilisedLimit)).toFixed(2);
                                    if (totalAbb !== calculatedLimit) {
                                        this.props.form.setFieldsValue({
                                            total_abb: calculatedLimit
                                        });
                                    }
                                }

                            }

                            if (fieldName === "max_emi_eligibility") {
                                const totalABB = this.props.form.getFieldValue('total_abb');
                                const marginB = this.props.form.getFieldValue('margin_b');
                                const maxEmiEligibility = this.props.form.getFieldValue('max_emi_eligibility');

                                if (totalABB != null && marginB != null) {
                                    const calculatedLimit = (Number(totalABB) * (marginB / 100)).toFixed(2);
                                    if (maxEmiEligibility !== calculatedLimit) {
                                        this.props.form.setFieldsValue({
                                            max_emi_eligibility: calculatedLimit
                                        });
                                    }
                                }

                            }
                            
                            if(fieldName == "max_loan_eligibility_abc"){
                                const totalABB = this.props.form.getFieldValue('total_abb');
                                const marginB = this.props.form.getFieldValue('margin_b');
                                const tenorC = this.props.form.getFieldValue("tenor_c");
                                const maxLoanEligibilityABC = this.props.form.getFieldValue("max_loan_eligibility_abc");

                                if (totalABB != null && marginB != null && tenorC != null) {
                                    const calculatedLimit = (Number(totalABB) * (marginB / 100 ) * tenorC).toFixed(2);
                                    if (maxLoanEligibilityABC !== calculatedLimit) {
                                        this.props.form.setFieldsValue({
                                            max_loan_eligibility_abc: calculatedLimit
                                        });
                                    }
                                }
                            }

                            if(fieldName == "max_eligibility_d"){

                                const gstToplineLastTwelveMonths = this.props.form.getFieldValue('gst_topline_last_twelve_months_a');
                                const marginBGst = this.props.form.getFieldValue('margin_b_gst');
                                const foirC = this.props.form.getFieldValue("foir_c");
                                const maxEligibilityD = this.props.form.getFieldValue("max_eligibility_d");

                                if (gstToplineLastTwelveMonths != null && marginBGst != null && foirC != null) {
                                    const calculatedLimit = (Number(gstToplineLastTwelveMonths) * ((marginBGst / 100) * (foirC / 100))).toFixed(2) || 0;
                                    if (maxEligibilityD !== calculatedLimit) {
                                        this.props.form.setFieldsValue({
                                            max_eligibility_d: calculatedLimit
                                        });
                                    }
                                }

                            }
                            if(fieldName == "max_loan_eligibility_d_e"){
                                const maxEligibilityD = this.props.form.getFieldValue('max_eligibility_d');
                                const currentObligationRunningEmiForTwelveMonths = this.props.form.getFieldValue('current_obligation_running_emi_for_twelve_months_e');
                                const maxLoanEligibilityDE= this.props.form.getFieldValue('max_loan_eligibility_d_e');

                                if (maxEligibilityD != null && currentObligationRunningEmiForTwelveMonths != null) {
                                    const calculatedLimit = (Number(maxEligibilityD) - Number(currentObligationRunningEmiForTwelveMonths)).toFixed(2);
                                    if (maxLoanEligibilityDE !== calculatedLimit) {
                                        this.props.form.setFieldsValue({
                                            max_loan_eligibility_d_e: calculatedLimit
                                        });
                                    }
                                }
                            }

                            if(fieldName == "ebidta_partner_remuneration"){
                                const pat_a = this.props.form.getFieldValue('pat_a');
                                const interest_b_financial = this.props.form.getFieldValue('interest_b_financial');
                                const depriciation_c= this.props.form.getFieldValue('depriciation_c');
                                const partner_remuneration_int_on_capital = this.props.form.getFieldValue('partner_remuneration_int_on_capital');
                                const ebidta_partner_remuneration = this.props.form.getFieldValue('ebidta_partner_remuneration');

                                if (pat_a != null && interest_b_financial != null && depriciation_c != null && partner_remuneration_int_on_capital != null) {
                                    const calculatedLimit = (Number(pat_a) + Number(interest_b_financial) + Number(depriciation_c) + Number(partner_remuneration_int_on_capital)).toFixed(2);
                                    if (ebidta_partner_remuneration !== calculatedLimit) {
                                        this.props.form.setFieldsValue({
                                            ebidta_partner_remuneration: calculatedLimit
                                        });
                                    }
                                }

                            }

                            if(fieldName == "debt_service"){
                                const twelve_month_existing_emi = this.props.form.getFieldValue('twelve_month_existing_emi');
                                const interest_b_financial = this.props.form.getFieldValue('interest_b_financial');
                                const twelve_month_new_emi = this.props.form.getFieldValue('twelve_month_new_emi');

                                const debt_service = this.props.form.getFieldValue('debt_service');

                                if(twelve_month_existing_emi != null && interest_b_financial != null && twelve_month_new_emi != null){
                                    const calculatedLimit = (Number(twelve_month_existing_emi) + Number(interest_b_financial) + Number(twelve_month_new_emi)).toFixed(2);
                                    if(debt_service !== calculatedLimit){
                                        this.props.form.setFieldsValue({
                                            debt_service: calculatedLimit
                                        });
                                    }

                                }
                            }

                            if(fieldName == "dscr_post"){
                                const ebidta_partner_remuneration = this.props.form.getFieldValue('ebidta_partner_remuneration');
                                const debt_service = this.props.form.getFieldValue('debt_service');
                                const dscr_post = this.props.form.getFieldValue('dscr_post');


                                if(ebidta_partner_remuneration != null && debt_service != null){
                                    const calculatedLimit = (Number(ebidta_partner_remuneration)/Number(debt_service)).toFixed(2) || 0;
                                    if(dscr_post !== calculatedLimit){
                                        this.props.form.setFieldsValue({
                                            dscr_post: calculatedLimit
                                        });
                                    }

                                }
                            }

                            if(fieldName == "working_capital_cycle"){
                                const stock_in_days = this.props.form.getFieldValue('stock_in_days');
                                const debtors_in_days = this.props.form.getFieldValue('debtors_in_days');
                                const creditor_in_days = this.props.form.getFieldValue('creditor_in_days');
                                const working_capital_cycle = this.props.form.getFieldValue('working_capital_cycle');

                                if(stock_in_days != null && debtors_in_days != null && creditor_in_days != null){
                                    const calculatedLimit = ((Number(stock_in_days) + Number(debtors_in_days)) - Number(creditor_in_days)).toFixed(2);
                                    if(working_capital_cycle !== calculatedLimit){
                                        this.props.form.setFieldsValue({
                                            working_capital_cycle: calculatedLimit
                                        });
                                    }

                                }
                            }

                            if(fieldName == 'working_capital_requirement'){
                                const working_capital_cycle = this.props.form.getFieldValue('working_capital_cycle');
                                const last_twelve_months_sales = this.props.form.getFieldValue('last_twelve_months_sales');
                                const working_capital_requirement = this.props.form.getFieldValue('working_capital_requirement');

                                if(working_capital_cycle != null && last_twelve_months_sales != null){
                                    const calculatedLimit = ((Number(working_capital_cycle) * Number(last_twelve_months_sales))/365 ).toFixed(2);
                                    if(working_capital_requirement !== calculatedLimit){
                                        this.props.form.setFieldsValue({
                                            working_capital_requirement: calculatedLimit
                                        });
                                    }

                                }
                            }

                            if(fieldName == "eligibility_working_capital"){
                                const working_capital_requirement = this.props.form.getFieldValue('working_capital_requirement');
                                const existing_working_capital_limits = this.props.form.getFieldValue('existing_working_capital_limits');
                                const eligibility_working_capital = this.props.form.getFieldValue('eligibility_working_capital');

                                if(working_capital_requirement != null && existing_working_capital_limits != null){
                                    const calculatedLimit = (Number(working_capital_requirement) - Number(existing_working_capital_limits)).toFixed(2);
                                    if(eligibility_working_capital !== calculatedLimit){
                                        this.props.form.setFieldsValue({
                                            eligibility_working_capital: calculatedLimit
                                        });
                                    }

                                }
                            }


                            if(fieldName == "total_current_asset"){
                                const stoct_current_asset = this.props.form.getFieldValue('stoct_current_asset');
                                const stock_wip = this.props.form.getFieldValue('stock_wip');
                                const current_asset_debtors = this.props.form.getFieldValue('current_asset_debtors');
                                const total_current_asset = this.props.form.getFieldValue('total_current_asset');

                                if(stoct_current_asset != null && stock_wip != null && current_asset_debtors != null){
                                    const calculatedLimit = (Number(stoct_current_asset) + Number(stock_wip) + Number(current_asset_debtors)).toFixed(2);
                                    if(total_current_asset !== calculatedLimit){
                                        this.props.form.setFieldsValue({
                                            total_current_asset: calculatedLimit
                                        });
                                    }
                                }
                            }

                            if(fieldName == "current_asset_eligibility"){
                                const total_current_asset = this.props.form.getFieldValue('total_current_asset');
                                const current_asset_eligibility = this.props.form.getFieldValue('current_asset_eligibility');
                                
                                if(total_current_asset != null){
                                    const calculatedLimit = ((Number(total_current_asset) * 25) / 100).toFixed(2);
                                    if(current_asset_eligibility !== calculatedLimit){
                                        this.props.form.setFieldsValue({
                                            current_asset_eligibility: calculatedLimit
                                        });
                                    }
                                }
                            }


                            if(fieldName == "industry_segment_eligibility"){
                                const industry_segment_gst_topline_last_twelve_month = this.props.form.getFieldValue('industry_segment_gst_topline_last_twelve_month');
                                const industry_wise_working_capital_cycle = this.props.form.getFieldValue('industry_wise_working_capital_cycle');
                                const industry_segment_eligibility = this.props.form.getFieldValue('industry_segment_eligibility');
                                
                                if(industry_segment_gst_topline_last_twelve_month != null && industry_wise_working_capital_cycle != null ){
                                    const calculatedLimit = ((Number(industry_segment_gst_topline_last_twelve_month) / 360) * Number(industry_wise_working_capital_cycle)).toFixed(2);
                                    if(industry_segment_eligibility !== calculatedLimit){
                                        this.props.form.setFieldsValue({
                                            industry_segment_eligibility: calculatedLimit
                                        });
                                    }
                                }
                            }

                            if(fieldName == "industry_segment_max_eligibility"){
                                const industry_segment_eligibility = this.props.form.getFieldValue('industry_segment_eligibility');
                                const existing_loans = this.props.form.getFieldValue('existing_loans');
                                const industry_segment_max_eligibility = this.props.form.getFieldValue('industry_segment_max_eligibility');
                                
                                if(industry_segment_eligibility != null && existing_loans != null ){
                                    const calculatedLimit = (Number(industry_segment_eligibility) - Number(existing_loans)).toFixed(2);
                                    if(industry_segment_max_eligibility !== calculatedLimit){
                                        this.props.form.setFieldsValue({
                                            industry_segment_max_eligibility: calculatedLimit
                                        });
                                    }
                                }
                            }



                            
                            return this.fieldGenerator(fieldName, field, this.getErrorOnField(fieldName))();
                        })
                        .toList()
                        .toArray()}


                    <div
                        style={{
                            position: 'absolute',
                            right: 0,
                            bottom: 0,
                            width: '100%',
                            borderTop: '1px solid #e9e9e9',
                            padding: '10px 16px',
                            background: '#fff',
                            textAlign: 'right',
                        }}
                    >
                        <Button style={{ marginRight: 8 }}>
                            Cancel
                        </Button>
                        <Button loading={this.state.loading} type="primary" htmlType="submit">
                            Submit
                        </Button>
                    </div>
                </Form>
            </Drawer>
        )
    }
}

export default Form.create({
    mapPropsToFields: ({ values }) => {
        return (
            values &&
            values
                .toSeq()
                .toMap()
                .map((value, key) => {
                    if(key === "sanction_date" || key === "agreement_end_date") {
                        return Form.createFormField({
                            value: value && moment(value)
                        });
                    }
                    return Form.createFormField({
                        value
                    });
                })
                .toJS()
        );
    }
})(EligibilityCalculatorDrawer);